import React from 'react';
import { useAtomValue } from 'jotai';
import { Box } from '@mui/system';

import { chatMessagesState } from '../../state/chat/ChatMessagesState';
import { loadingChatMessageState } from '../../state/chat/LoadingChatMessageState';
import { BotAnswerAnimation } from './BotAnswerAnimation';
import { ShowImageDialog } from './ShowImageDialog';
import { ChatMessageBox } from './ChatMessageBox';

function getMessageTimestampValue(message) {
    const parsed = new Date(message?.sentAt).getTime();
    return Number.isFinite(parsed) ? parsed : 0;
}

function getMessageKey(message, index) {
    return message?.id || `${message?.sender || message?.role || 'message'}-${message?.sentAt || index}-${message?.message || ''}`;
}

export function ChatMessageList() {
    const messages = useAtomValue(chatMessagesState);
    const isLoading = useAtomValue(loadingChatMessageState);

    const sortedMessages = [...messages]
        .map((message, index) => ({ message, index }))
        .sort((a, b) => {
            const timeDifference = getMessageTimestampValue(a.message) - getMessageTimestampValue(b.message);
            return timeDifference !== 0 ? timeDifference : a.index - b.index;
        })
        .map((entry) => entry.message);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.9, pb: 1.25, pt: 0.35 }}>
            <ShowImageDialog />
            {sortedMessages.map((message, index) => (
                <Box key={getMessageKey(message, index)}>
                    <ChatMessageBox
                        message={message}
                        isLatest={index === sortedMessages.length - 1}
                    />
                </Box>
            ))}
            {isLoading && <BotAnswerAnimation />}
        </Box>
    );
}
